import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'aggErrorHeading'
	| 'aggErrorMessage'
	| 'aggErrorMessageSubtext'
	| 'aggErrorAction';

const message: Record<MessageKeys, { defaultMessage: string; description?: string; id: string }> =
	defineMessages({
		aggErrorHeading: {
			id: 'studio-foundations.common.agg-error-page.aggErrorHeading',
			defaultMessage: "We can't connect",
			description: 'Heading for AGG Network Error page',
		},
		aggErrorMessage: {
			id: 'studio-foundations.common.agg-error-page.aggErrorMessage',
			defaultMessage:
				"We're having trouble verifying your account. Try logging in again. If the problem persists, contact support and reference the error code displayed below.",
			description: 'Message for AGG Network Error page',
		},
		aggErrorMessageSubtext: {
			id: 'studio-foundations.common.agg-error-page.aggErrorMessageSubtext',
			defaultMessage: 'Error code: AGG',
			description: 'Subtext for AGG Network Error page (error code)',
		},
		aggErrorAction: {
			id: 'studio-foundations.common.agg-error-page.aggErrorAction',
			defaultMessage: 'Log in again',
			description: 'Action for AGG Network Error page',
		},
	});

export default message;
